import { PluginStore } from "graylog-web-plugin/plugin";
import View from "views/logic/views/View";
import { exportSearchMessages, exportSearchTypeMessages } from "util/MessagesExportUtils";
const _getWidgetById = (widgets, id) => widgets.find((item) => item.id === id);
const _initialSearchWidget = (widgets, directExportWidgetId) => {
  if (directExportWidgetId) {
    return _getWidgetById(widgets, directExportWidgetId);
  }
  if (widgets.size === 1) {
    return widgets.first();
  }
  return null;
};
export const formatDefinition = (format) => {
  const formats = PluginStore.exports("views.export.formats");
  const definition = formats.find(({ type }) => type === format);
  if (!definition) {
    throw new Error(`Unknown export format "${definition}"`);
  }
  return definition;
};
const _exportOnDashboard = (format, payload, searchType, searchId, filename) => {
  if (!searchType) {
    throw new Error("Exports on a dashboard require a selected widget!");
  }
  const { mimeType, fileExtension } = formatDefinition(format);
  const filenameWithExtension = `${filename}.${fileExtension}`;
  return exportSearchTypeMessages(payload, searchId, searchType.id, mimeType, filenameWithExtension);
};
const _exportOnSearchPage = (format, payload, searchQueries, searchType, searchId, filename) => {
  if (searchQueries.size !== 1) {
    throw new Error("Searches must only have a single query!");
  }
  const { mimeType, fileExtension } = formatDefinition(format);
  const filenameWithExtension = `${filename}.${fileExtension}`;
  if (searchType) {
    return exportSearchTypeMessages(payload, searchId, searchType.id, mimeType, filenameWithExtension);
  }
  return exportSearchMessages(payload, searchId, mimeType, filenameWithExtension);
};
const SearchExportStrategy = {
  title: "Export all search results",
  shouldEnableDownload: (showWidgetSelection, _selectedWidget, selectedFields, loading) => !loading && !showWidgetSelection && !!selectedFields && selectedFields.length > 0,
  shouldAllowWidgetSelection: (singleWidgetDownload, showWidgetSelection, widgets) => !singleWidgetDownload && !showWidgetSelection && widgets.size > 1,
  shouldShowWidgetSelection: (singleWidgetDownload, selectedWidget, widgets) => !singleWidgetDownload && !selectedWidget && widgets.size > 1,
  initialWidget: _initialSearchWidget,
  downloadFile: (format, payload, searchQueries, searchType, searchId, filename) => _exportOnSearchPage(format, payload, searchQueries, searchType, searchId, filename)
};
const DashboardExportStrategy = {
  title: "Export message table search results",
  shouldEnableDownload: (_showWidgetSelection, selectedWidget, selectedFields, loading) => !loading && !!selectedWidget && !!selectedFields && selectedFields.length > 0,
  shouldAllowWidgetSelection: (singleWidgetDownload, showWidgetSelection) => !singleWidgetDownload && !showWidgetSelection,
  shouldShowWidgetSelection: (singleWidgetDownload, selectedWidget) => !singleWidgetDownload && !selectedWidget,
  initialWidget: (widget, directExportWidgetId) => directExportWidgetId ? _getWidgetById(widget, directExportWidgetId) : null,
  downloadFile: (format, payload, _searchQueries, searchType, searchId, filename) => _exportOnDashboard(format, payload, searchType, searchId, filename)
};
const createExportStrategy = (viewType) => {
  switch (viewType) {
    case View.Type.Dashboard:
      return DashboardExportStrategy;
    case View.Type.Search:
    default:
      return SearchExportStrategy;
  }
};
export default { createExportStrategy };
